import React from 'react';
import PropTypes, { oneOfType } from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

const BadgeContainer = (props) => {
  const {
    title = '',
    subtitle = '',
    children,
    isComplete = true,
    showCheck = false,
    showLine = false,
    boldLine = false,
    badgeSize = 'md',
  } = props;

  // badgeSize prop / css class match.
  const badgeSizes = {
    sm: 'small',
    md: 'medium', //assumed default in css
    // "lg":"large",
    // "xl":"xlarge"
  };

  const lineClasses = clsx('line', {
    'line--bold': boldLine,
  });

  return (
    <div className="badgeContainer">
      <div className="containerHeader">
        {title.length > 0 && <h1 className="badgeContainer__title">{title}</h1>}
        {showCheck && (
          <div className={`check ${isComplete ? 'completed' : ''}`}>
            <FontAwesomeIcon icon={['fas', 'check-circle']} size="2x" />
          </div>
        )}
      </div>
      {subtitle.length > 0 && <h2 className="badgeContainer__subtitle">{subtitle}</h2>}
      <div className={`badgeGrid ${badgeSizes[badgeSize]}`}>{children}</div>
      {showLine && <div className={lineClasses} />}
    </div>
  );
};

BadgeContainer.propTypes = {
  // Components within the container group. Usually Badge (or similar) components.
  children: PropTypes.arrayOf(oneOfType(PropTypes.element, PropTypes.arrayOf(PropTypes.element))),
  // Rendered title for the container group.
  title: PropTypes.string,
  // Determines the checkmark styling (greyed out for false, green for true)
  isComplete: PropTypes.bool,
  // If true, adds a greyed out line between the title/header and the badges
  showLine: PropTypes.bool,
  // If false, removes the 'completed' checkmark.
  showCheck: PropTypes.bool,
  // Default assumed: 'md'. Will adjust the .badgeGrid css by adding subclass with altered grid-template-colum max width.
  badgeSize: PropTypes.oneOf('sm', 'md'),
};

export default BadgeContainer;
